module.exports = __webpack_public_path__ + "img/bottomImg.1761f4f7.png";